import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const mainGetPoultries = createAsyncThunk(
  "MAIN_GET_POULTRIES",
  async (province) => {
    const axiosInstance = axios.create();
    axiosInstance.defaults.headers.common = {};

    const apiUrl = `https://${
      province === "hamedan" ? "ha" : "ma"
    }backend.rasadyar.com/poultry-loc/`;

    try {
      const response = await axiosInstance.get(apiUrl);
      const { data, status } = response;
      return { data, status };
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);
